import { getSearchSessionId } from './search-session';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

/**
 * Docs: https://aha-move.atlassian.net/wiki/spaces/ahaai/pages/4263477328/AF-02+Log+2+button+t+ngay+Chat+t+m+n
 */
export type EventTrackingType =
  | 'click_button' //
  | 'check_fb_log_in' //
  | 'log_in_success' // Khi user đã đăng nhập thành công vào Facebook Messenger (và theo dõi thêm như có lấy được fb_id hay không).
  | 'chatbot_event'
  | 'order_event'
  | 'search_event'
  | 'click_item_card' // When user clicks on store card
  | 'add_to_cart' // When user adds item to cart
  | 'view_store' // When user views store details
  | 'click_search_suggestion' // When user clicks on search suggestion
  | 'meal_plan'
  | 'solomeal_event'; // Events related to SoloMeal feature

const shouldTrackEvent = () => {
  // Enable tracking if environment variable is true OR if we're in development and debugging
  return (
    process.env.NEXT_PUBLIC_ENABLE_TRACKING_EVENT === 'true' ||
    (process.env.NODE_ENV === 'development' && typeof window !== 'undefined')
  );
};

export const trackEvent = (
  eventType: EventTrackingType,
  eventParameters: Record<string, any> = {}
) => {
  try {
    // Check if running in a browser environment
    if (typeof window !== 'undefined' && shouldTrackEvent()) {
      // Initialize dataLayer if it doesn't exist
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      // Automatically include search_id if it exists (except for search_event which manages its own search_id)
      const searchId =
        eventType !== 'search_event' ? getSearchSessionId() : null;

      const enhancedParameters = {
        ...eventParameters,
        ...(searchId && { search_id: searchId }),
      };

      console.log('[Tracked]', eventType, enhancedParameters);
      window.dataLayer.push({
        event: 'custom_event',
        eventType,
        ...enhancedParameters,
      });
    } else {
      console.log('[Not Tracked]', eventType, eventParameters);
    }
  } catch (error) {
    console.log('TRACKING ERROR: ', error);
  }
};
